export default {"src":"/_next/static/media/industrial-land-icon-selected.bdf13c25.svg","height":104,"width":108,"blurWidth":0,"blurHeight":0};